const getTanstackTableSortKey = (key: string) => {
  return key.replace(".", "_"); //react-table applies this transform internally, not sure why
};

export default getTanstackTableSortKey;
